import { defineComponent, h, Transition, TransitionGroup } from 'vue';

const makeTransition = (name) => defineComponent({
  name,
  props: {
    duration: {
      type: [Number, Object],
      default: 300
    },
    group: Boolean
  },
  setup(props, { slots }) {
    return () => h(props.group ? TransitionGroup : Transition, {}, slots);
  }
});

export const CollapseTransition = makeTransition('CollapseTransition');
export const FadeTransition = makeTransition('FadeTransition');
export const SlideYDownTransition = makeTransition('SlideYDownTransition');
export const SlideYUpTransition = makeTransition('SlideYUpTransition');
export const SlideXLeftTransition = makeTransition('SlideXLeftTransition');
export const SlideXRightTransition = makeTransition('SlideXRightTransition');
export const ScaleTransition = makeTransition('ScaleTransition');
export const ZoomCenterTransition = makeTransition('ZoomCenterTransition');
